import React from "react"

interface IProps {
  onClick: (...args: any) => any
  title: string
}

/**
 * Provides an element that reacts on onClick and looks like a link
 */
const LinkButton: React.FC<IProps> = (props: IProps) => {
  const { onClick, title } = props
  return <span className="looks-like-a-link clickable" onClick={onClick}>{title}</span>
}

export default LinkButton
